module.exports = __webpack_public_path__ + "5c114213/img/google.68f3823e.svg";